import nonVSSpacesBase from "./nonVSSpacesBase";
import { SpaceConfig } from "./spaceConfig";
import { SpaceId } from "./spaceIds";
import { UnknownSlugWorkaround } from "./spacesBase";

const spaceDotnet: SpaceConfig = {
    ...nonVSSpacesBase,
    id: SpaceId.DotNet,
    displayName: ".NET",
    slug: UnknownSlugWorkaround,
    spaceTag: { type: "feature", value: ".net" },
};

export default spaceDotnet;
